import { Route, Routes } from "react-router-dom";
import { Suspense,lazy } from "react";
import OpenRoute from "./components/auth/openRoute"
import PrivateRoute from "./components/auth/privateRoute";
import Loader from "./components/loader/Loader";


const SignUp = lazy(() => import("./components/auth/signUp/SignUp"));
const Error=lazy(()=>import("./components/error/Error"))
const ResetPasswordPage=lazy(()=>import("./components/auth/resetPasswordPage"))
const ChangePassword=lazy(()=>import("./components/auth/changePassword"))
const Login=lazy(()=>import("./components/auth/login/Login"))
const OtpVerified=lazy(()=>import("./components/auth/login/OtpVerified"))
const OnBoarding=lazy(()=>import("./components/auth/onBoarding/onBoarding"))
const DashboardLayout=lazy(()=>import("./components/vendorPortal/common/Layout"))
const VendorDashboard=lazy(()=>import("./components/vendorPortal/Dashboard/vendorDashboard"))
const Product=lazy(()=>import("./components/vendorPortal/Product/Product"))
const ProductList=lazy(()=>import("./components/vendorPortal/productList/productList"))
const VerifyPage=lazy(()=>import("./components/auth/verifyPage"))
const Payout=lazy(()=>import("./components/vendorPortal/payout/Payout"))
const Sale=lazy(()=>import("./components/vendorPortal/sales/Sale"))
const Dispute=lazy(()=>import("./components/vendorPortal/dispute/Dispute"))
const Inventory=lazy(()=>import("./components/vendorPortal/inventory/Inventory"))
const Order=lazy(()=>import("./components/vendorPortal/orders/Order"))
 const ProductDetail=lazy(()=>import("./components/vendorPortal/productList/productDetail"))
const LmsDashboard=lazy(()=>import("./components/LMS/LmsDashboard/Dashboard"))
const Main=lazy(()=>import("./components/LMS/CourseLibrary/Main"))
const Certificate=lazy(()=>import("./components/LMS/Certificates/Main"))
const Badge=lazy(()=>import("./components/LMS/Badge/Main"))
const LeaderBoard=lazy(()=>import("./components/LMS/LeaderBoard/Main"))
const ArtisanProfile=lazy(()=>import("./components/LMS/ArtisanProfile/Main"))


function App() {
  return (
    <div className="App">
      <Suspense fallback={<Loader/>}>

      <Routes>
          <Route path='/' element={
          <OpenRoute>
          <SignUp/>
          </OpenRoute>
          }/>
         <Route path='/join' element={
          <OpenRoute>
          <SignUp/>
          </OpenRoute>
          }/>
            <Route path='/verify-email' element={
          <OpenRoute>
          <VerifyPage/>
          </OpenRoute>
          }/>
         <Route path='/login' element={
          <OpenRoute>
             <Login/>
          </OpenRoute>
         }/>
         <Route path='/forget-password' element={
          <OpenRoute>
             <ResetPasswordPage/>
          </OpenRoute>
         }/>
          <Route path='/reset-password' element={
            <OpenRoute>
              <ChangePassword/>
            </OpenRoute>
            }/>
           <Route path='/verify' element={
            <OpenRoute>
              <OtpVerified/>
            </OpenRoute>
            }/>
           <Route path='/onboarding' element={
            
              <OnBoarding/>
              
            }/>
             <Route
         path="/vendor-dashboard"
          element={
           <PrivateRoute>
            <DashboardLayout/>
           </PrivateRoute> 
           
          }
        >
          <Route index element={<VendorDashboard/>} />
          <Route path='product' element={<Product/>} />
           <Route path='product-list' element={<ProductList/>} />
           <Route path='product-detail/:id' element={<ProductDetail/>} />
           <Route path='my-sales' element={<Sale/>} />
            <Route path='orders' element={<Order/>} />
             <Route path='payout' element={<Payout/>} />
             <Route path='dispute' element={<Dispute/>} />
             <Route path='inventory' element={<Inventory/>} />
             <Route path="learn">
                <Route path="dashboard" element={<LmsDashboard />} />
                <Route path="course-library" element={<Main/>} />
                <Route path="certificates" element={<Certificate/>} />
                <Route path='badges' element={<Badge/>}/>
                 <Route path='leaderbord' element={<LeaderBoard/>}/>
                  <Route path='artisan-profile' element={<ArtisanProfile/>}/>
             </Route>
        </Route>
         <Route path="*" element={<Error/>}/>
      </Routes>
      </Suspense>
    </div>
  );
}

export default App;
